module.exports = __webpack_public_path__ + "static/media/teo-logo-big.8c56d6a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teo-logo-big.png
// module id = 1861
// module chunks = 0